import * as React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Region } from '../../BookingsCalendarTypes';
import { Translate } from '../../../../../shared/LanguageService';

export type RegionFilterLabels = {
    region: string;
    allRegions: string;
};

type ExternalProps = {
    onChangeRegion: (event: React.ChangeEvent<{ value: unknown; }>) => void;
    selectedRegion: string;
    regions: Region[];
};

type RegionFilterProps = {
    labels: RegionFilterLabels;
} & ExternalProps;

const RegionFilter = (props: RegionFilterProps) => {
    const { regions, labels, onChangeRegion, selectedRegion } = props;

    return (
        <TextField
            fullWidth
            select
            id="select-region"
            label={[labels.region]}
            name={'selectedRegion'}
            value={selectedRegion}
            onChange={onChangeRegion}
        >
            <MenuItem value={''} sx={{ fontWeight: '600' }}>
                {labels.allRegions}
            </MenuItem>
            {regions.map((region) => (
                <MenuItem key={region.id} value={region.id}>
                    {region.name}
                </MenuItem>
            ))}
        </TextField>
    );
};

const RegionFilterTranslationLayer = (props: ExternalProps) => {
    let labels: RegionFilterLabels = {
        region: Translate('orders/list/bookings-calendar/region'),
        allRegions: Translate('orders/list/bookings-calendar/all-regions')
    };

    return <RegionFilter labels={labels} {...props} />;
};

export default RegionFilterTranslationLayer;
